
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResizeVerticalBottom as ObiResizeVerticalBottomElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resize-vertical-bottom.js';
 
 
 

 
 export const ObiResizeVerticalBottom = createComponent({
   react: React,
   tagName: 'obi-resize-vertical-bottom',
   elementClass: ObiResizeVerticalBottomElement,
   events: {
     
   }
  });
 
 